<template>
    <div class="score-input">
        <button
            v-for="(i, index) in options"
            class="clearfix far fa-heart"
            v-on:click.prevent="setValue(i)"
            v-bind:class="{
                lower: isLower(i),
                greater: isGreater(i),
                active: isActive(i),
            }"
            :key="index"
        >
            <slot name="button-content"></slot>
            <span class="score-number">{{ i }}</span>
        </button>

        <input type="hidden" ref="input" :value="value" />
    </div>
</template>
<script>
export default {
    name: "score",
    props: {
        value: String,
    },
    data: function () {
        return {
            maxOptions: 10,
        };
    },
    computed: {
        options: function () {
            var options = [];
            for (var i = 0; i <= this.maxOptions; i++) {
                options.push(i);
            }
            return options;
        },
    },
    methods: {
        setValue: function (value) {
            this.value = value;
            this.$emit("input", value);
        },
        isLower: function (v) {
            return v < this.value;
        },
        isGreater: function (v) {
            return v > this.value;
        },
        isActive: function (v) {
            return v == this.value;
        },
    },
};
</script>
